<template>
  <div class="col-12 col-xl-3 ml-auto mr-auto">
    <card type="login" plain>
      <div slot="header" class="text-center">
        <h3 class="d-none d-sm-block">Quero saber mais</h3>
        <h5 class="d-block d-sm-none">Quero saber mais</h5>
      </div>

      <fg-input
        class="no-border input-lg"
        addon-left-icon="now-ui-icons users_circle-08"
        placeholder="Primeiro nome"
        v-model="name"
        :validations="$v.name"
        :contrast="true"
      >
      </fg-input>

      <fg-input
        class="no-border input-lg"
        addon-left-icon="now-ui-icons ui-1_email-85"
        placeholder="Email"
        v-model="email"
        :validations="$v.email"
        :contrast="true"
      >
      </fg-input>

      <fg-input
        class="no-border input-lg"
        addon-left-icon="now-ui-icons tech_mobile"
        placeholder="Telefone"
        v-bind:mask="['(##) ####-####', '(##) #####-####']"
        v-model="phone"
        :validations="$v.phone"
        :contrast="true"
      >
      </fg-input>

      <template slot="raw-content">
        <div class="card-footer text-center">
          <button
            v-on:click="evtCreateLead"
            class="btn btn-primary btn-round btn-lg btn-block"
            >Continuar</button
          >
        </div>
      </template>
    </card>
  </div>
</template>

<script>
import { Card, Button, FormGroupInput } from "@/components";
import { required, email } from "vuelidate/lib/validators";

export default {
  name: "login-page",
  bodyClass: "login-page",
  data: function () {
    return {
      name: "",
      email: "",
      phone: "",
    };
  },
  components: {
    Card,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput,
  },
  methods: {
    evtCreateLead: async function () {
      
      if (!this.evtCheckForm())
        return false

      await this.$store.dispatch("lead/create", {
        data: this.evtGetForm(),
      });

      this.evtClearForm()
    },
    evtCheckForm: function () {
      
      let formValid = true

      this.$v.name.$touch()
      if (this.$v.name.$error === true)
        formValid = false

      this.$v.email.$touch()
      if (this.$v.email.$error === true)
        formValid = false

      this.$v.phone.$touch()
      if (this.$v.phone.$error === true)
        formValid = false

      return formValid

    },  
    evtClearForm() {

      this.$v.$reset()
      this.name = ""
      this.phone = ""
      this.email = ""
      

    }, 
    evtGetForm() {
      let form = {
        Name: this.$data.name,
        Email: this.$data.email,
        Phone: this.$data.phone,
      };

      return form;
    },
  },
  validations: {
    name: { required },
    email: { required, email },
    phone: { required },
  },
};
</script>
<style></style>
